<template>
  <div>
    <div id="flag"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    const flag = document.getElementById("flag");
    for (var i = 0; i < flag.offsetWidth; i++) {
      var flag_img = document.createElement("div");
      flag_img.className = "flag_img";
      flag_img.style.backgroundPosition = -i + "px";
      flag_img.style.animationDelay = i * 10 + "ms";
      flag.append(flag_img);
    }
  },
};
</script>
<style>
#flag {
  width: 250px;
  height: 140px;
}
.flag_img {
  position: relative;
  background-image: url("../assets/images/iranFlag2.png");
  background-size: 250px 100%;
  height: 100%;
  width: 1px;
  display: inline-block;
  animation: wave 1s ease-in-out infinite alternate;
}
@keyframes wave {
  0% {
    top: 5%;
  }
  100% {
    top: -5%;
  }
}
</style>
